export function convertYouTubeToEmbed(url: string) {
  const urlObj = new URL(url);

  const videoId = urlObj.searchParams.get('v');
  const playlistId = urlObj.searchParams.get('list');

  if (!videoId) {
    throw new Error('Invalid YouTube URL: missing video ID');
  }

  let embedUrl = `https://www.youtube.com/embed/${videoId}`;
  if (playlistId) {
    embedUrl += `?list=${playlistId}`;
  }

  return embedUrl;
}
